import { z } from "zod";

const validationSchemas = {
  required: (message: string) => z.string().min(1, message),
  email: (message: string) => z.email({ message }),
  minLength: (length: number, message: string) =>
    z.string().min(length, message),
  maxLength: (length: number, message: string) =>
    z.string().max(length, message),
  minValue: (min: number, message: string) =>
    z.coerce.number().gte(min, message),
  maxValue: (max: number, message: string) =>
    z.coerce.number().lte(max, message),
  pattern: (regex: RegExp, message: string) =>
    z.string().regex(regex, { message }),
  isInteger: (message: string) => z.coerce.number().int({ message }),
  minArrayLength: (length: number, message: string) =>
    z.array(z.any()).min(length, message),
};

export { validationSchemas };
